import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBenefitCardIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M26.2155 10.3111C26.6078 10.0054 27.1126 9.86628 27.8015 10.0529L40.0424 14.4703C41.5877 14.9901 42.3324 16.018 41.8584 17.3983L35.4168 35.1836C35.0853 36.1641 34.2764 37.257 33.0594 36.8846L27.0118 34.8729",
		stroke: "currentColor",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.36106 13.5449L21.7599 9.06499C23.1154 8.60415 24.539 8.21439 25.4091 10.2989L32.5118 30.0032C33.4508 32.1554 32.2849 33.2751 30.8837 33.7091L17.9518 38.3868C15.4543 39.0178 14.6809 38.7114 13.6189 35.6881L12.1345 31.4786M12.1542 31.5495L7.07983 17.2581C6.09059 14.7667 7.48339 14.1652 9.40943 13.5318",
		stroke: "currentColor",
		strokeWidth: 2
	})]
});
export default SvgBenefitCardIcon;
